import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import logo from '../assets/logo-bvt.png'; // Reemplaza por el logo correcto

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <nav className="fixed top-6 left-1/2 transform -translate-x-1/2 w-[90%] bg-white/90 backdrop-blur-md shadow-md rounded-xl z-50">
      <div className="flex justify-between items-center h-16 px-6">
        <div className="flex items-center space-x-2">
          <img src={logo} alt="CJH Transportation Logo" className="h-14" />
        </div>

        <div className="space-x-6 hidden md:flex">
          <Link to="/" className="text-gray-700 hover:text-[#003366] transition">Home</Link>
          <Link to="/services" className="text-gray-700 hover:text-[#003366] transition">Services</Link>
          <Link to="/contact" className="text-gray-700 hover:text-[#003366] transition">Contact</Link>
        </div>

        <div className="md:hidden">
          <button onClick={() => setIsOpen(!isOpen)} className="text-gray-700 text-2xl">☰</button>
        </div>
      </div>

      {isOpen && (
        <div className="md:hidden px-6 pb-4">
          <Link to="/" className="block py-2 text-gray-700 hover:text-[#003366]" onClick={() => setIsOpen(false)}>Home</Link>
          <Link to="/services" className="block py-2 text-gray-700 hover:text-[#003366]" onClick={() => setIsOpen(false)}>Services</Link>
          <Link to="/contact" className="block py-2 text-gray-700 hover:text-[#003366]" onClick={() => setIsOpen(false)}>Contact</Link>
        </div>
      )}
    </nav>
  );
};

export default Navbar;
